import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { JPDCollectionConfigProviderEntrypointProps } from './JPDCollectionConfigProvider.entrypoint.types.tsx';

type JPDCollectionConfigProviderEntrypointComponent = EntryPointComponent<
	{},
	{},
	JPDCollectionConfigProviderEntrypointProps,
	{} | null
>;

export const jpdCollectionConfigProviderEntrypoint: EntryPoint<
	JPDCollectionConfigProviderEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<JPDCollectionConfigProviderEntrypointComponent>(
		/* webpackChunkName: "ai-rovo-actions-polaris-collection-provider" */ './JPDCollectionConfigProviderEntry.tsx',
	),
	getPreloadProps: () => ({}),
});
